<script lang="ts">
  import AppShell from './app/AppShell.svelte';
</script>

<AppShell />
